/** @jsxImportSource react */
import RatingBadge from '@react/shared/components/RatingBadge';
import { getScoreTextAndIntent } from '@react/shared/helpers/ratingBadge';

interface ScoreGraphicProps {
  score: number;
  total: number;
  type: string;
}

const ScoreGraphic = ({ score, total, type }: ScoreGraphicProps) => {
  const { color: scoreColor } = getScoreTextAndIntent(Number(score));

  return (
    <div className='flex flex-row gap-4'>
      <RatingBadge
        className='flex-shrink-0'
        intent={scoreColor}
        size='small'
        rating={String(score)}
      />
      <div>
        <div className='font-t-xs-azo'>
          Average Seniorly Community score of {type} communities
        </div>
        <div className='font-b-s'>{total} assisted living communities</div>
      </div>
    </div>
  );
};

export default ScoreGraphic;
